import { Helmet } from 'react-helmet-async';

/**
 * Robot component for dynamically generating robots.txt content
 * This allows for environment-specific robots rules
 */
const Robot = () => {
  // You can make this dynamic based on environment variables if needed
  const isProduction = true; // process.env.NODE_ENV === 'production';
  const baseUrl = 'https://biodata360.in';
  
  // Note: Robots.txt content is now pre-generated and served as a static file

  return (
    <Helmet>
      <meta name="robots" content={isProduction ? 'index, follow' : 'noindex, nofollow'} />
      {/* This link helps search engines discover the robots.txt file */}
      <link rel="robots" href={`${baseUrl}/robots.txt`} />
    </Helmet>
  );
};

export default Robot;